import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=8a8ef4e4&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a8ef4e4')) {
      api.createRecord('8a8ef4e4', component.options)
    } else {
      api.reload('8a8ef4e4', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=8a8ef4e4&", function () {
      api.rerender('8a8ef4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/Content.vue"
export default component.exports